import { Component, HostListener, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
// import * as AOS from 'aos';
import { ConstantService } from './service/constant.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.styl']
})
export class AppComponent implements OnInit {
  fullScreenStatus = false;
  Data: boolean = false;
  @HostListener('document:click', ['$event'])
  clickout() {
    // this.GameBetDetails.Runner = '';
    sessionStorage.setItem('FullScreen', 'true');
    this.fullScreenStatus = false;
  }
  constructor(public translate: TranslateService, public constant: ConstantService) {

    const allLang: { key: string, value: string }[] = [
      { key: 'en', value: 'English' },
      { key: 'gu', value: 'Gujarati' },
      { key: 'hi', value: 'Hindi' },
      { key: 'mr', value: 'Marathi' },
      { key: 'ta', value: 'Tamil' },
      { key: 'te', value: 'Telugu' },
      { key: 'km', value: 'Kannada' },
      { key: 'ml', value: 'Malayalam' },
      { key: 'ar', value: 'Arabic' },
      { key: 'cn', value: 'Cantonese' },
      { key: 'id', value: 'Indonesian' },
      { key: 'ja', value: 'Japanese' },
      { key: 'ko', value: 'Korean' },
      { key: 'ms', value: 'Malay' },
      { key: 'tl', value: 'Philipino' },
      { key: 'ru', value: 'Russian' },
      { key: 'th', value: 'Thai' },
      { key: 'tb', value: 'Tibetan' },
      { key: 'vi', value: 'Vietnamese' },
    ];
    // const allLang = ['English', 'Gujarati', 'Hindi', 'Marathi', 'Tamil', 'Telugu', 'Kannada', 'Malayalam', 'Arabic', 'Cantonese', 'Indonesian', 'Japanese', 'Korean', 'Malay', 'Philipino', 'Russian', 'Thai', 'Tibetan', 'Vietnamese'];
    // const allLang = ['en', 'gu', 'hi', 'mr', 'ta', 'te', 'km', 'ml', 'ar', 'cn', 'id', 'ja', 'ko', 'ms', 'tl', 'ru', 'th', 'tb', 'vi'];
    // translate.addLangs(['English', 'Gujarati', 'Hindi']);
    translate.addLangs(['en', 'gu', 'hi', 'mr', 'ta', 'te', 'km', 'ml', 'ar', 'cn', 'id', 'ja', 'ko', 'ms', 'tl', 'ru', 'th', 'tb', 'vi']);
    translate.setDefaultLang('en');
    const url = new URL(window.location.href);
    let PrevLang = sessionStorage.getItem('Lng');
    let Lng = '';
    
    if (PrevLang != null && PrevLang != undefined && allLang.hasOwnProperty(PrevLang.trim())) {
      Lng = PrevLang;
      // sessionStorage.setItem('Lng', Lng.trim());
    } else {
      Lng = url.searchParams.get('ln');
      if (Lng != null && Lng != '' && allLang.hasOwnProperty(Lng.trim())) {
        sessionStorage.setItem('Lng', Lng.trim());
      } else {
        Lng = 'en';
        sessionStorage.setItem('Lng', Lng.trim());
      }
    }
    if (Lng != null && Lng != '' && allLang.hasOwnProperty(Lng.trim())) {
      translate.use(Lng.trim());
      this.constant.translate = translate;
    } else {
      translate.use('en');
      this.constant.translate = translate;
    }
  }
  title = 'clientapp';
  ngOnInit() {
    // AOS.init({
    //   offset: 0,
    //   once: true,
    //   duration: 600,
    //   easing: 'ease-in-sine',
    //   delay: 0,
    // });
    let FullScreen: boolean = Boolean(sessionStorage.getItem('FullScreen'));
    if (FullScreen === false) {
      this.fullScreenStatus = true;
    }
    if (this.Data === true) { this.Data = false };
    setTimeout(() => {
      this.Data = true;
    }, 500);
    this.overrideLocalStorage();
    // Start Disabled inspact
    document.addEventListener('contextmenu', (e) => {
      e.preventDefault();
    });

    document.onkeydown = (e) => {
      if (e.key && e.key.toUpperCase() === 'F12') {
        return false;
      }
      if (e.ctrlKey) {
        return false;
      }
      if (e.ctrlKey && e.shiftKey && e.key.toUpperCase() === 'I') {
        return false;
      }
      if (e.ctrlKey && e.shiftKey && e.key.toUpperCase() === 'C') {
        return false;
      }
      if (e.ctrlKey && e.shiftKey && e.key.toUpperCase() === 'J') {
        return false;
      }
      if (e.ctrlKey && e.key.toUpperCase() === 'U') {
        return false;
      }
    };
    // End Disabled inspact
  }

  fullScreen(value: boolean) {
    var elem = document.documentElement;
    if (value) {
      elem.requestFullscreen();
      this.fullScreenStatus = false;
    } else {
      document.exitFullscreen();
    }
    sessionStorage.setItem('FullScreen', 'true');
  }

  overrideLocalStorage() {
    Storage.prototype.setItem = function (key, value) {
      if (this === window.sessionStorage) {
        key = btoa(encodeURIComponent(btoa(escape(encodeURIComponent(key || '')))));
        value = btoa(encodeURIComponent(btoa(escape(encodeURIComponent(value || '')))));
      } else {
        // fallback to default action
      }
      this[key] = value;
    };
    Storage.prototype.getItem = function (key) {
      if (this === window.sessionStorage) {
        try {
          key = btoa(encodeURIComponent(btoa(escape(encodeURIComponent(key || '')))));
        } catch { }
      } else {
        // fallback to default action
      }
      let value = this[key];
      if (value) {
        try {
          value = decodeURIComponent(unescape(atob(decodeURIComponent(atob(value || '')))));
        } catch { }
      }
      return value;
    };
    Storage.prototype.removeItem = function (key) {
      if (this === window.sessionStorage) {
        try {
          key = btoa(encodeURIComponent(btoa(escape(encodeURIComponent(key || '')))));
        } catch { }
      } else {
      }
      delete this[key];
    };
  }
}
